import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useResetUserPassword } from "../../api/users";
import { useToast } from "../../components/ToastProvider";

export function ResetPasswordModal({
  userId,
  userName,
  onClose,
}: {
  userId: number | null;
  userName: string;
  onClose: () => void;
}) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const reset = useResetUserPassword();
  const toast = useToast();

  if (!userId) return null;
  const targetId = userId;

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (password.length < 8) return setError("A senha precisa ter pelo menos 8 caracteres.");
    try {
      await reset.mutateAsync({ id: targetId, password });
      toast(`Senha de ${userName} redefinida.`);
      setPassword("");
      setError(null);
      onClose();
    } catch {
      setError("Não foi possível redefinir a senha.");
    }
  }

  return (
    <Modal backdrop="static" keyboard={false} show onHide={onClose} centered className="nt-dialog">
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title style={{ fontSize: 20, fontFamily: "var(--font-heading)" }}>Redefinir senha · {userName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div>
            <label className="form-label" style={{ fontSize: 12 }}>
              Nova senha
            </label>
            <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && (
            <div className="text-danger" style={{ fontSize: 12.5 }}>
              {error}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-danger" onClick={onClose}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-success" disabled={reset.isPending}>
            Redefinir
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
